import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

const PocketDeal = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();

  const {state} = useLocation()
  const user = state?.user
  
  const handleClose = () => setVisible(false); // Only trigger animation

  useEffect(() => {
    if (!visible) {
      // Wait for animation to finish before redirecting
      const timer = setTimeout(() => {
        setIsOpen(false);
        navigate('/dashboard', { replace: true });
      }, 400); // Match this with your animation duration

      return () => clearTimeout(timer); // Cleanup
    }
  }, [visible, navigate]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        // backgroundColor: 'rgba(0, 0, 0)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.4s ease',
        zIndex: 1050,
      }}
    >
      <div
        style={{
          width: '100%',
          marginTop:'5rem',
          maxWidth: '900px',
          minHeight: '550px',
          backgroundColor: '#fff',
          borderRadius: '24px',
          padding: '68px 36px',
          boxShadow: '0 20px 50px rgba(0, 0, 0, 0.35)',
          transform: visible ? 'translateY(0)' : 'translateY(-40px)',
          transition: 'transform 0.4s ease',
          position: 'relative',
          textAlign: 'center',
        }}
      >
        {/* Close Button */}
        <button
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '42px',
            height: '42px',
            border: 'none',
            borderRadius: '50%',
            backgroundColor: '#f5f5f5',
            fontSize: '22px',
            cursor: 'pointer',
            lineHeight: '42px',
            transition: 'background-color 0.2s ease',
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
        >
          ✕
        </button>

        {/* Header */}
        <h2
          style={{
            fontSize: '45px',
            color: '#f15623',
            fontWeight: '800',
            marginBottom: '24px',
          }}
        >
          🎉 Payment Successful!
        </h2>

        {/* User Info */}
        <p style={{ fontSize: '22px', margin: '16px 0', color: '#333' }}>
          Thank you for registering, <strong>{user?.userName}</strong>!
        </p>
        <p style={{ fontSize: '18px', margin: '10px 0', color: '#555' }}>
          Phone Number: <strong>{user?.phoneNumber}</strong>
        </p>
        <p style={{ fontSize: '16px', marginTop: '30px', color: '#6c757d' }}>
          Your Pocket Deal account is ready. Download the app below and login with your phone number.
        </p>

        {/* Download Button */}
        <a
          href={user?.downloadLink}
          onClick={handleClose}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'block',
            width: '40%',
            margin:'auto',
            marginTop: '52px',
            padding: '18px 0',
            backgroundColor: '#f15623',
            color: '#fff',
            borderRadius: '16px',
            fontSize: '20px',
            fontWeight: '700',
            textDecoration: 'none',
            transition: 'background-color 0.3s ease',
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#d94d1e')}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f15623')}
        >
          📥 Download Pocket Deal App
        </a>

        {/* Footer */}
        <footer style={{ marginTop: '32px' }}>
          <small style={{ color: '#7a7a7a', fontSize: '15px' }}>
            Need help? Contact our support team anytime.
          </small>
        </footer>
      </div>
    </div>
  );
};

export default PocketDeal;
